function Error500Page() {
    return <>에러 500페이지(필요시 사용)</>;
}

export default Error500Page;
